<script lang="ts" setup>
import BaseVGrid from "@/components/BaseVGrid.vue";

defineProps<{
  zeitbereich?: APIZeitbereich;
  queryAic?: number;
}>();
const emit = defineEmits<{
  (event: "onReloadData"): void;
}>();
</script>
<template>
  <BaseVGrid
    query="Web_DetailsSonstBelegeMA_DetailmaskeKI"
    :zeitbereich="zeitbereich"
    :queryAic="queryAic"
    :showClose="false"
    @onReloadData="emit('onReloadData')"
  ></BaseVGrid>
</template>
